import { useQuery, gql, QueryHookOptions } from '@apollo/client';
import {
  GQLPlatformMerchantOrderWithPlatformProducerOrder,
  GQLPlatformMerchantOrderWithPlatformProducerOrderConnection,
  GQLQueryPlatform_GetAllPlatformMerchantOrderWithPlatformProducerOrdersArgs
} from '@jewelutions/core-crm-server-api-client-domain';
import { PLATFORM_MERCHANT_ORDER_WITH_PLATFORM_PRODUCER_ORDER } from './fragments/order';
import { OperationsHelper } from './OperationHelper';

export class PlatformOperation {
  platformMerchantOrderWithPlatformProducerOrderArrayFromResponse(
    data: any
  ): GQLPlatformMerchantOrderWithPlatformProducerOrder[] {
    return OperationsHelper.retrievePropertyFromGQLResponse(
      data,
      'platformMerchantOrderWithPlatformProducerOrders'
    );
  }

  getAllPlatformMerchantOrderWithPlatformProducerOrders(
    args: GQLQueryPlatform_GetAllPlatformMerchantOrderWithPlatformProducerOrdersArgs,
    options: QueryHookOptions<
      GQLPlatformMerchantOrderWithPlatformProducerOrderConnection,
      GQLQueryPlatform_GetAllPlatformMerchantOrderWithPlatformProducerOrdersArgs
    > = {}
  ) {
    const query = gql`
      ${PLATFORM_MERCHANT_ORDER_WITH_PLATFORM_PRODUCER_ORDER}
      query Platform_getAllPlatformMerchantOrderWithPlatformProducerOrders {
        Platform_getAllPlatformMerchantOrderWithPlatformProducerOrders(pageSize: 10) {
          cursor
          hasMore
          platformMerchantOrderWithPlatformProducerOrders {
            ...PlatformMerchantOrderWithPlatformProducerOrderFields
          }
        }
      }
    `;
    return useQuery<
      GQLPlatformMerchantOrderWithPlatformProducerOrderConnection,
      GQLQueryPlatform_GetAllPlatformMerchantOrderWithPlatformProducerOrdersArgs
    >(query, {
      ...options,
      variables: args
    });
  }
}
